import { render } from "./Transaction.vue?vue&type=template&id=0f7c21cb"
import script from "./Transaction.vue?vue&type=script&lang=ts"
export * from "./Transaction.vue?vue&type=script&lang=ts"
script.render = render

export default script